module.exports = __webpack_public_path__ + "img/Illustration-MD-2024.df023385.png";